import { render, staticRenderFns } from "./InfrastructureCollisions.vue?vue&type=template&id=6e497110&"
import script from "./InfrastructureCollisions.vue?vue&type=script&lang=js&"
export * from "./InfrastructureCollisions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports